import { render, staticRenderFns } from "./CustomVueTableCard.vue?vue&type=template&id=110d95e6&"
import script from "./CustomVueTableCard.vue?vue&type=script&lang=js&"
export * from "./CustomVueTableCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports